import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  avatar: {
    background: theme.palette.common.white,
    boxShadow: theme.shadows[4],
    width: 32,
    height: 32,
  },
  avatarImg: {
    width: 18,
    height: 18,
  },
  popperRoot: {
    flexGrow: 1,
  },
  list: {
    margin: 0,
    listStyle: 'none',
    padding: 0,
  },
  listItem: {
    padding: 20,
    '& img': {
      maxWidth: 55,
      margin: '0 auto 15px',
    },
    width: 125,
    color: theme.palette.grey['A800'],
    fontWeight: theme.typography.fontWeightBold,
    fontFamily: theme.font.secondary,
    boxSizing: 'border-box',
  },
}));
